<template>

  <div class="form" style="margin-top: 250px" >
    <v-card  class="grey lighten-5">
      <br/>
      <h1 align="center" style="text-decoration: underline overline">
        Daftar Batch
      </h1>
      <br/>
      <br/>
      
    <v-row>
      <v-col cols="6">
        Penyelia Prosesan
        <v-text-field
          v-model="namaPProsesan"
          hint="namaPProsesan"
          outline
          disabled
          dense
          class="mr-2"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        Penyelia Operasi
        <v-text-field
          v-model="namaPOperasi"
          hint="namaPOperasi"
          outline
          disabled
          dense
          class="mr-2"
        ></v-text-field>
      </v-col>
    </v-row>

    Current Role : {{ role }}

    <v-card class="mb-2 mt-2" color="rgba(245, 245, 238, 1)">
      <v-container>
        <v-form ref="formsimpanbatch" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="1">
              <v-text-field
                outlined
                dense
                v-model="paparkodnegeri"
                label="Kod Negeri"
                required
                disabled
              ></v-text-field>
            </v-col>

            <v-col cols="1">
              <v-text-field
                outlined
                dense
                v-model="paparkaw"
                label="KAW"
                required
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-select
                :items="senaraipusingan"
                :item-text="item => item.pusingan +' - '+ item.tahun"
                v-bind:label="$t('pusingan')"
                return-object
                outlined
                dense
                @change="tukarpusingan($event)"
                v-model="PUSINGAN"
              ></v-select>
            </v-col>

            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="paparbulan"
                v-bind:label="$t('bulan')"
                required
                disabled
              ></v-text-field>
            </v-col>

            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="papartahun"
                v-bind:label="$t('tahun')"
                required
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-show="bahagiantambahbatch">
            <v-card-title>
              {{ $t("tambahbbatch") }}
            </v-card-title>
          </v-row>
          <v-row v-show="bahagiantambahbatch">
            
            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="BNO"
                v-on:keyup="semakbnowujud()"
                v-bind:label="$t('bno')"
                :rules="[required('bno'), rules.BNOlength, rules.bnosudahwujud]"
                :messages="msgbnosudahwujud"
                type="number"
                required
                hint="contoh : 003" 
                persistent-hint
              ></v-text-field>
            </v-col>

            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="JumBorang"
                v-bind:label="$t('jumlahborang')"
                type="number"
                :rules="[required('jumlahborang'),rules.jumlahBorang]"
                max=30
                required
              ></v-text-field>
            </v-col>

            <v-col>
              <v-btn
                :disabled="!valid"
                color="success"
                class="mr-4"
                @click="simpanbatch"
              >
                {{ $t("tambah") }}
              </v-btn>
            </v-col>
          </v-row>

          <!-- Button -->
          <!-- <v-row class="ml-4 mb-2">
                <v-btn
                :disabled="!valid"
                color="success"
                class="mr-4"
                @click="simpan"
                >
                Simpan
                </v-btn>
                <v-btn
                color="error"
                class="mr-4"
                @click="Padam"
                >
                Padam
                </v-btn>
                <v-btn
                color="warning"
                @click="reset"
                >
                Clear
                </v-btn>
      </v-row> -->
        </v-form>

        <!-- DATATABLE Senarai Batch  -->
        <v-card>
          <v-card-title>
            {{ $t("senaraibatch") }}
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="dataBatch"
            :search="search"
            class="ml-3 mr-3"
            @click:row="handleClick"
          ></v-data-table>
        </v-card>
        <!-- DATATABLE Senarai Batch  -->
      </v-container>
    </v-card>

    <!-- <v-dialog
      v-model="rowClick"
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5">
          Testing
        </v-card-title>

        <v-card-text >
          <div v-for="(value,name, index) in papardatabatch" v-bind:key="index">
            {{ name }} : {{ value }}
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="warning"
            @click="rowClick = false"
            >
            CANCEL
          </v-btn>


          <v-btn
            color="primary"
            @click="update()"
            >
            UPDATE
          </v-btn>

          <v-btn
          color="error"
          @click="padam()"
          >
          PADAM
          </v-btn>
        </v-card-actions>
      </v-card>
</v-dialog> -->

    <v-dialog v-model="rowClick" max-width="1000" persistent>
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("databatch") }}
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col>
              {{ $t("bno") }}
              <v-text-field
                outlined
                dense
                v-model="papardatabatch.bno"
                disabled
                readonly
              ></v-text-field>
            </v-col>
            <v-col>
              {{ $t("jumlahborang") }}
              <v-text-field
                outlined
                dense
                v-model="papardatabatch.jumborang"
                required
              ></v-text-field>
            </v-col>
            <!-- <v-col>
              {{ $t("borangselesai") }}
              <v-text-field
                outlined
                dense
                v-model="papardatabatch.borangselesai"
                readonly
              ></v-text-field>
            </v-col> -->
          </v-row>

          <v-row>
            <v-col>
              {{ $t("penyeliaoperasi") }}
              <v-text-field
                outlined
                dense
                v-model="papardatabatch.po"
                readonly
              ></v-text-field>
            </v-col>
            <v-col>
              {{ $t("penyeliaprosesan") }}
              <v-text-field
                outlined
                dense
                v-model="papardatabatch.pp"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="warning" @click="rowClick = false"> {{ $t("batal")}} </v-btn>

          <v-btn color="primary" @click="updatebatch(papardatabatch)"> {{ $t("kemaskini")}} </v-btn>

          <v-btn color="error" @click="padam(papardatabatch.batchid)">
            {{ $t("padam")}}
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
    <v-dialog v-model="modalkemaskinipppo" persistent width="1000">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ $t("tetapkanpppo") }}
        </v-card-title>
        <v-container>
          <Pppoinput></Pppoinput>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="successDialog" width="500" height="200">
      <v-card color="success">
        <v-alert dense outlined color="#C51162" type="success">
          <strong>{{ successMessage }}</strong>
        </v-alert>
      </v-card>
    </v-dialog>


<!-- Error Dialog -->
<v-dialog
      v-model="errorDialog"
      width="500"
      height="200"
    >
    <v-card>
      <v-alert
        dense
        outlined
        color="#C51162"
        type="error"
      >
      <strong>{{errMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>

<!-- Success Dialog -->
<v-dialog
      v-model="successDialog"
      max-width="800"
      height="200"
    >
    <v-card
      color="success"
    >
      <v-alert
        dense
        outlined
        color="#C51162"
        type="success"
      >
      <strong>{{successMessage}}</strong>
      </v-alert>

      <!-- <v-card-actions> 
        <v-spacer></v-spacer>
            <v-btn
                color="warning"
                @click='successDialog = false;'
            >
              Batal
            </v-btn>
            <v-btn
              color="primary"
              @click='goTo("2")'
            >
              Pengisian Seterusnya
            </v-btn>
      </v-card-actions> -->
    </v-card>
</v-dialog>

<!-- Kemaskini Dialog -->
<v-dialog
      v-model="kemaskiniDialog"
      max-width="800"
      height="200"
    >
    <v-card
    >
      <v-alert
        dense
        solo
      >
      <strong>Data Dipilih, Sila Mulakan Pengemaskinian</strong>
      </v-alert>
    </v-card>
</v-dialog>
</v-card>
  </div>
</template>
<script>
// import VueRouter from 'vue-router'
import axios from "../../plugins/axios";
//////////////services//////////////////
import getPusingan from "@/services/pusingan";
const paparpusingan = new getPusingan();

import schemeRule from '@/utils/scheme'

import getLocalStorage from "@/services/getLocalStorage";
const localStorageData = new getLocalStorage();
import i18n from "@/i18n";
import Pppoinput from "@/components/Pppoinput/pppoinput";
export default {
  components: {
    Pppoinput,
  },
  beforeMount() {
    this.userData = localStorageData.user();
    this.namaPOperasiID = localStorageData.po().poid;
    this.namaPOperasi = localStorageData.po().namapo;
    this.namaPProsesan = localStorageData.pp().namapp;
    this.namaPProsesanID = localStorageData.pp().ppid;
    this.KODNEG = this.userData.kodneg;
    this.role = this.userData.role;
    this.KAW = "1";
    this.PO = "1";
    this.PP = "1";
    this.penciptaID = this.userData.id;
    this.paparkodnegeri = this.userData.kodneg;
    this.paparkaw = this.userData.kaw;
    this.paparsenaraipusingan();
    //this.getBatchData();
    this.semakpppo();
    this.msgbnosudahwujud = "";
    // const testbatchServices = new getbatchServices();
    // var testing123 = testbatchServices.sendRequest();
    // alert(testing123)
  },
  setup() {},
  data: () => ({
    successDialog: false,
    errorDialog: false,
    successMessage:'',
    kemaskiniDialog: false,
    errMessage:'',
    message: "Saving Data",
    popUpALert:false,

    //successMessage: "",
    //successDialog: false,
    bnotextcolor: "",
    msgbnosudahwujud: "",
    modalkemaskinipppo: false,
    userData: "",
    contoh1: false,
    contoh2: false,
    search: "",
    role: "",
    rowClick: false,
    papardatabatch: [],
    bahagiantambahbatch: false,
    paparkodnegeri: "",
    paparkaw: "",
    paparbulan: "",
    papartahun: "",
    paparpusingan: "",
    KAW: "",
    BULAN: "",
    TAHUN: new Date().getFullYear(),
    KODNEG: "",
    PUSINGAN: "",
    BNO: "",
    JumBorang: "",
    BorangSelesai: 0,
    PP: "",
    namaPProsesan: "",
    namaPProsesanID: "",
    PO: "",
    namaPOperasi: "",
    namaPOperasiID: "",
    penciptaID: "",
    dataBatch: [],
    senaraipusingan: [],
    required(text) {
      return (v) =>
        (v && v.length > 0) || `${i18n.t(text)} ${i18n.t("adalahdiperlukan")}`;
    },
    rules: {
      BNOlength: (value) => {
        return (value && value.length == 3) || `${i18n.t("minmax3digit")}`;
      },
      bnosudahwujud: () => true || this.msgbnosudahwujud,
      jumlahBorang: (value)=>{
        return (value <= 30) || `${i18n.t("Maximum Borang hanyalah 30")}`;
      }
    },
    headers: [
      { text: "#", value: "no" },
      {
        text: i18n.t("bno"),
        align: "start",
        sortable: false,
        value: "bno",
      },
      { text: i18n.t("jumlahborang"), value: "jumborang" },
      { text: i18n.t("penyeliaprosesan"), value: "pp" },
      { text: i18n.t("penyeliaoperasi"), value: "po" },
    ],
    valid: true,
    select: null,
  }),
  mounted() {
    this.modalkemaskinipppo = localStorageData.checkpppo() === 0 ? false : true;
    this.paparbtntutup = true;
  },
  methods: {
    async semakbnowujud() {
      try {
        if (this.BNO.length >= 3) {
     
          const semakbnowujud = {
            semakkaw: this.paparkaw,
            semakbulan: this.paparbulan,
            semaktahun: this.papartahun,
            semakpusingan: this.paparpusingan,
            semakbno: this.BNO,
          };
          await axios
            .post(
              `${process.env.VUE_APP_API_URL}/batch/semaknobatchwujud`,
              semakbnowujud
            )
            .then((result) => {
              this.msgbnosudahwujud = "";
              this.rules.bnosudahwujud = true;
              if (!result.data.status) {
                this.msgbnosudahwujud = i18n.t("bnosudahwujud");
                this.rules.bnosudahwujud = false;
              } else {
                this.msgbnosudahwujud = "";
                this.rules.bnosudahwujud = true;
              }
            });
        } else {
          this.msgbnosudahwujud = "";
          this.rules.msgbnosudahwujud = true;
        }
      } catch (err) {
        alert(err);
      }
    },
    async handleClick(row) {
      this.rowClick = true;
      this.papardatabatch = row;
    },
    async simpanbatch(req) {
      if (this.$refs.formsimpanbatch.validate()) {
        try {
          let result = await axios.post(
            `${process.env.VUE_APP_API_URL}/batch/daftar`,
            {
              KAW: this.paparkaw,
              BULAN: this.paparbulan,
              TAHUN: this.papartahun,
              KODNEG: this.paparkodnegeri,
              PUSINGAN: this.paparpusingan,
              BNO: this.BNO,
              JumBorang: this.JumBorang,
              ppID: this.namaPProsesanID,
              namaPProsesan: this.namaPProsesan,
              poID: this.namaPOperasiID,
              namaPOperasi: this.namaPOperasi,
              penciptaID: this.penciptaID,
            }
          );
          if (!result.data.status) {
            alert(result.data.message);
          } else {
            this.getBatchData(); //refresh DataTable
            this.successDialog = true;
            setTimeout(() => (this.successDialog = false), 2000);
            this.successMessage = "Data Disimpan!";
            req.pusingan = this.paparpusingan;
            req.bulan = this.paparbulan;
            req.tahun = this.papartahun;
            this.getBatchData(req);
          }
        } catch (error) {
          console.log(error);
          alert("error");
        }
      }
    },
    async updatebatch(req) {

        try {
          let result = await axios.post(
            `${process.env.VUE_APP_API_URL}/batch/update`,
            {
              // KAW: this.paparkaw,
              // BULAN: this.paparbulan,
              // TAHUN: this.papartahun,
              KODNEG: this.paparkodnegeri,
              PUSINGAN: this.paparpusingan,
              BNO: req.bno,
              JumBorang: req.jumborang
              // ppID: this.namaPProsesanID,
              // namaPProsesan: this.namaPProsesan,
              // poID: this.namaPOperasiID,
              // namaPOperasi: this.namaPOperasi,
              // penciptaID: this.penciptaID,
            }
          );
          if (!result.data.status) {
            alert(result.data.message);
          } else {
            //this.getBatchData(); //refresh DataTable
            this.rowClick = false;
            this.successDialog = true;
            setTimeout(() => (this.successDialog = false), 2000);
            this.successMessage = "Data Dikemaskini!";
            req.pusingan = this.paparpusingan;
            req.bulan = this.paparbulan;
            req.tahun = this.papartahun;
            this.getBatchData(req);
          }
        } catch (error) {
          console.log(error);
          alert("error");
        }

    },
    async padam(batchID) {
      try {
        await axios.post(`${process.env.VUE_APP_API_URL}/batch/delete`, {
          batchID: batchID,
          KODNEG: this.paparkodnegeri
        });

        //this.res = res.data
        // this.successDialog = true;
        // setTimeout(() => (this.successDialog = false), 2000);
        // this.successMessage = 'Data Deleted!'
        // this.saveButton = false;
        // this.updateButton = true;
        // this.reset();
        this.successDialog = true;
        this.successMessage = 'Data Dipadam!';
        setTimeout(() => (this.successDialog = false), 2000);
        window.location.reload()
        //this.getBatchData(); //refresh dataTable
      } catch (error) {
        console.log(error);
        // this.errorDialog = true;
        // setTimeout(() => (this.errorDialog = false), 2000);
        // this.errMessage = 'Padam : '+error;
      }
      this.rowClick = false;
    },
    async paparsenaraipusingan() {
      var res = await paparpusingan.getPusinganData();
      var listPusinganAll = res.data.data;
      this.senaraipusingan = listPusinganAll.filter(obj => obj[this.KODNEG] === 1);
      
    },
    async tukarpusingan(req) {
      this.BULAN = this.PUSINGAN.bulan;
      this.TAHUN = this.PUSINGAN.tahun;

      this.bahagiantambahbatch = true;
      this.paparbulan = this.PUSINGAN.bulan;
      this.papartahun = this.PUSINGAN.tahun;
      this.paparpusingan = this.PUSINGAN.pusingan;
      req.pusingan = this.paparpusingan;
      req.bulan = this.paparbulan;
      req.tahun = this.papartahun;
      this.getBatchData(req);
    },
    async semakpppo() {
      // this.$router.push(`/${i18n.locale}/tetapkanpenyeliaprosesanoperasi/batch`)
      await axios.get(`${process.env.VUE_APP_API_URL}/pppo/semakpppo`);
    },
    async getBatchData(req) {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/batch/getBatch?KODNEG=${this.KODNEG}&P=${req.pusingan}&T=${req.tahun}&B=${req.bulan}`
        );
        const Batch = [];
        res.data.data.forEach(async function (element, index) {
          Batch.push({
            no: `${index + 1}`,
            batchid: `${element.batchID}`,
            bno: `${element.BNO}`,
            jumborang: `${element.JumBorang}`,
            borangselesai: `${element.BorangSelesai}`,
            pp: `${element.namaPProsesan}`,
            po: `${element.namaPOperasi}`,
          });
        });
        this.dataBatch = Batch;
      } catch (error) {
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "getData : " + error;
      }
    },
  },
  watch: {},
};
</script>

<style>
/* #app {
  background: url('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQXkzLF-Z_EN24HQWzXIt5XOtRd7ptmZmbHgkiNtvbV6q4Rown_qxtdudAs4rLf0WqGN2c&usqp=CAU')
    no-repeat center center fixed !important;
  background-size: cover;
} */
</style>

<style scoped>
.v-text-field .poskod {
  width: 400px;
}

.v-card {
  display: flex !important;
  flex-direction: column;
}

.v-card__text {
  flex-grow: 1;
  overflow: auto;
}
</style>

